export default function RegisterPage() {
    return (
        <div>
            Register
        </div>
    );
}
